<div class="flexible-column">
<header *ngIf="tableData == undefined">
  <app-header></app-header>
</header>
<div class="flex-grow">
<div class="flexible-column">
  <div class="display-flex">
    <app-page-title class="test" pageTitle='Case Details'>
    </app-page-title>
    <button style="color: #6A0721;" (click)="openDialogForSearch()">
      Advanced Search
      <span class="material-icons">
        search
      </span>
    </button>
  </div>
  <div *ngIf="showSpinner; else content" class="flex-grow">
    <app-spinner  style="position: absolute;top: 40%;"
    ></app-spinner>
  </div>
  <ng-template #content>
    <!-- <h3 style="color: #9B9B9B" class="header-enf">Showing Results for<span style="padding:5px;color:#000">{{searchForm.get('streetNo').value}}  {{selectedAddress.street}}</span></h3> -->
    <!-- <div class = "box"> -->
    <!-- <app-table [tableData]="caseList"  [tableColumnsNames]="columnNames"></app-table>  -->
    <div *ngIf="caseList != undefined && caseList.length">
      <div class="box">
        <table mat-table #table [dataSource]="dataSource" matSort>
          <!-- <ng-container [matColumnDef]="column" *ngFor="let column of columnNames;"> 
              <ng-container *ngIf="column !== 'actions';">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>  {{tableColumnsNames ? tableColumnsNames[column] : column}} </th>
                <td mat-cell *matCellDef="let object"> {{object[column]}} </td>
                </ng-container>
            </ng-container>   -->
          <ng-container matColumnDef="Case">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Case Id</th>
            <td mat-cell *matCellDef="let element"> {{element.Case}} </td>
          </ng-container>
          <ng-container matColumnDef="Date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
            <td mat-cell *matCellDef="let element"> {{element.Date | date:'dd/MM/yy'}} </td>
          </ng-container>
          <ng-container matColumnDef="Violation">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Violation</th>
            <td mat-cell [title]=element.Violation class="extra-cls" *matCellDef="let element"> {{element.Violation}}
            </td>
          </ng-container>
          <ng-container matColumnDef="User">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>User</th>
            <td mat-cell [title]=element.User class="extra-cls" *matCellDef="let element"> {{element.User}} </td>
          </ng-container>
          <ng-container matColumnDef="StreetNo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Street No</th>
            <td mat-cell *matCellDef="let element"> {{element.StreetNo}} </td>
          </ng-container>
          <ng-container matColumnDef="Street">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Street</th>
            <td mat-cell [title]=element.Street class="extra-cls" *matCellDef="let element"> {{element.Street}} </td>
          </ng-container> 
          <ng-container matColumnDef="DaystoCure">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Days</th>
            <td mat-cell *matCellDef="let element" class="date-cls"> {{element.DaystoCure}} </td>
          </ng-container>
          <ng-container matColumnDef="Category">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Category</th>
            <td mat-cell *matCellDef="let element">
              <!-- <mat-select  [placeholder]="element.Category" [value]="element.Category" >
                  <mat-option  *ngFor="let dep of categories " [value]="dep.category" >
                    {{ dep.category }}
                  </mat-option>
                </mat-select> -->
              {{element.Category}}
            </td>
          </ng-container>
          <ng-container matColumnDef="Status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell
              [ngStyle]="element.Status=='Open'?{'color':'green','font-weight':'bold'} : {'color': 'grey','font-weight':'bold'}"
              *matCellDef="let element"> {{element.Status}} </td>
          </ng-container>
          <ng-container matColumnDef="ExpiryDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Expiry Date</th>
            <td mat-cell *matCellDef="let element"> {{element.ExpiryDate | date:'dd/MM/yy'}} </td>
          </ng-container>
          <ng-container matColumnDef="IsExpired">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Expired/Not Expired</th>
            <td mat-cell
              [ngStyle]="element.IsExpired=='Expired'?{'color':'red','font-weight':'bold'} : {'color': 'black'}"
              *matCellDef="let element"> {{element.IsExpired}} </td>
          </ng-container>
          <!-- actions -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="text-right">
              Actions
            </th>
            <td mat-cell *matCellDef="let row; let i=index;" class="text-left">
              <button [ngStyle]="row.Status=='Closed'?{'color':'grey'} : {'color': 'null'}" [disabled]="row.Status == 'Closed'" style="background: transparent;" class="material-icons custom-material-icon"
                (click)="openDialogUpdateForm(row)">
                edit
              </button>
              <button style="background: transparent;" class="material-icons custom-material-icon"
                (click)="deleteItem(row)">
                delete
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
          <tr mat-row *matRowDef="let row; columns: columnNames;" class="example-element-row"
            class="example-element-row">
          </tr>
        </table>
        <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
      </div>
    </div>
    <!-- </div> -->
    <p *ngIf="caseList == undefined || caseList.length == 0" class="no-data">No Data Found</p>       
  </ng-template>
</div>
</div>
<ng-template #formRef>
  <div class="dialog-Container">
    <mat-dialog-actions class="d-inline-block float-right">
      <h4 class="d-inline-block">Edit Fields</h4>
      <button mat-dialog-close class="dialog-btn-trans text-white">X</button>
    </mat-dialog-actions>
    <mat-dialog-content class="dialog-content">
      <!-- <p class="sub-form-title mandator-title dialog-sub-title">* All fields are required</p> -->
      <form class="address-form" action="" [formGroup]="updateCaseListForm" (submit)="onSubmit()">
        <mat-form-field appearance="fill">
          <mat-label>Days</mat-label>
          <mat-select formControlName="daysToCureId">
            <mat-option *ngFor="let day of days" [value]="day.id">{{day.numberOfDays}}</mat-option>
          </mat-select>
          <mat-error *ngIf="updateCaseListForm.get('daysToCureId').hasError('required')">
            Please select days to cure
          </mat-error>
          <!-- <mat-error *ngIf="!userForm.get('role').hasError('required') && userForm.get('role').hasError('patternValidation')">
            Special character or space not allow at start
          </mat-error> -->
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Category</mat-label>
          <mat-select formControlName="categoryId">
            <mat-option *ngFor="let category of categories" [value]="category.id">{{category.category}}</mat-option>
          </mat-select>
          <mat-error *ngIf="updateCaseListForm.get('categoryId').hasError('required')">
            Please select category
          </mat-error>
        </mat-form-field>
        <mat-error style="text-align: left; font-size: 75%; margin-top: -13px;" *ngIf="closeStatus && (updateCaseListForm.controls.statusId.value == closeStatus[0].id) &&  resolvedCategory && (updateCaseListForm.controls.categoryId.value != resolvedCategory[0].id)">
          Please select resolved category
        </mat-error>
        <!-- <p style="color:red;"
          *ngIf="closeStatus && (updateCaseListForm.controls.statusId.value == closeStatus[0].id) &&  resolvedCategory && (updateCaseListForm.controls.categoryId.value != resolvedCategory[0].id)">
          Please select Resolve Category
        </p> -->
        <mat-form-field appearance="fill">
          <mat-label>Status</mat-label>
          <mat-select formControlName="statusId">
            <mat-option *ngFor="let status of status" [value]="status.id">{{status.status}}</mat-option>
          </mat-select>
          <mat-error *ngIf="updateCaseListForm.get('statusId').hasError('required')">
            Please select days to cure
          </mat-error>
          <!-- <mat-error *ngIf="!userForm.get('role').hasError('required') && userForm.get('role').hasError('patternValidation')">
        Special character or space not allow at start
      </mat-error> -->
        </mat-form-field>
        <!-- <p style="color:red;"
          *ngIf="resolvedCategory && (updateCaseListForm.controls.categoryId.value == resolvedCategory[0].id) && openStatus && (updateCaseListForm.controls.statusId.value == openStatus[0].id)">
          Please select closed status
        </p> -->
        <mat-error style="text-align: left; font-size: 75%; margin-top: -13px;" *ngIf="resolvedCategory && (updateCaseListForm.controls.categoryId.value == resolvedCategory[0].id) && openStatus && (updateCaseListForm.controls.statusId.value == openStatus[0].id)">
          Please select closed status
        </mat-error>
        <button mat-button class="button-primary"
          [disabled]='updateCaseListForm.invalid || closeStatus && (updateCaseListForm.controls.statusId.value == closeStatus[0].id) &&  resolvedCategory && (updateCaseListForm.controls.categoryId.value != resolvedCategory[0].id) || resolvedCategory && (updateCaseListForm.controls.categoryId.value == resolvedCategory[0].id) && openStatus && (updateCaseListForm.controls.statusId.value == openStatus[0].id)'
          type="submit" color="vov-ui-primary">Update case</button>
        <!-- <button mat-button  class="button-primary" [disabled]='updateCaseListForm.invalid' type="submit"
          color="vov-ui-primary">Update case</button> -->
      </form>
    </mat-dialog-content>
  </div>
</ng-template>

<ng-template #confirmRef>
  <div class="dialog-Container">
    <h3 mat-dialog-title>Are you sure you want to delete?</h3>
    <mat-dialog-content class="delete-Conatiner">
      <button mat-button color="vov-ui-primary" class="confirm-btn confirm" (click)="confirmDelete()">Delete</button>
      <button mat-button (click)="onNoClick()" class="confirm-btn cancel" tabindex="-1">Cancel</button>
    </mat-dialog-content>
  </div>
</ng-template>

<ng-template #searchFormRef> 
  <div class="dialog-Container">
    <mat-dialog-actions class="d-inline-block float-right" style="padding:0px;">
      <h4 class="d-inline-block">Advanced Search</h4>
      <button mat-dialog-close class="dialog-btn-trans text-white" (click)="clear()">X</button>
    </mat-dialog-actions>
    <mat-dialog-content class="dialog-content">
      <!-- <p class="sub-form-title mandator-title dialog-sub-title">* All fields are required</p> -->
      <form class="address-form" action="" [formGroup]="searchForm" (submit)="fetchAllCases()">
        <mat-form-field appearance="fill">
          <mat-label>Case</mat-label>
          <input matInput type="test" formControlName="case"/>
          <!-- <mat-label>Case</mat-label>
          <input type="text"  aria-label="Number" matInput formControlName="case"
            [matAutocomplete]="auto">
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
              {{option}}
            </mat-option>
          </mat-autocomplete> -->
        </mat-form-field>
        <!-- <mat-form-field  appearance="fill">
        <mat-label>Days</mat-label>
        <mat-select formControlName="daysToCureId">
          <mat-option  *ngFor="let day of days"  [value]="day.id">{{day.numberOfDays}}</mat-option>
        </mat-select> -->
        <!-- <mat-error *ngIf="onSubmitSearchForm.get('daysToCureId').hasError('required')">
           Please select days to cure    
         </mat-error> -->
        <!-- </mat-form-field> -->
        <mat-form-field appearance="fill">
          <mat-label>Category</mat-label>
          <mat-select formControlName="categoryId">
            <mat-option *ngFor="let category of categories" [value]="category.id">{{category.category}}</mat-option>
          </mat-select>
          <!-- <mat-error *ngIf="onSubmitSearchForm.get('categoryId').hasError('required')">
           Please select days to cure    
         </mat-error> -->
          <!-- <mat-error *ngIf="!userForm.get('role').hasError('required') && userForm.get('role').hasError('patternValidation')">
          Special character or space not allow at start
        </mat-error> -->
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Status</mat-label>
          <mat-select formControlName="statusId">
            <mat-option *ngFor="let status of status" [value]="status.id">{{status.status}}</mat-option>
          </mat-select>
          <!-- <mat-error *ngIf="onSubmitSearchForm.get('statusId').hasError('required')">
         Please select days to cure    
       </mat-error> -->
          <!-- <mat-error *ngIf="!userForm.get('role').hasError('required') && userForm.get('role').hasError('patternValidation')">
        Special character or space not allow at start
      </mat-error> -->
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Expired/Not Expired</mat-label>
          <mat-select formControlName="isExpired">
            <mat-option [value]="1">Expired</mat-option>
            <mat-option [value]="0">Not Expired</mat-option>
            <!-- <mat-option  *ngFor="let status of status"  [value]="status.id">{{status.status}}</mat-option> -->
          </mat-select>
          <!-- <mat-error *ngIf="onSubmitSearchForm.get('isExpired').hasError('required')">
       Please select days to cure    
     </mat-error> -->
          <!-- <mat-error *ngIf="!userForm.get('role').hasError('required') && userForm.get('role').hasError('patternValidation')">
      Special character or space not allow at start
    </mat-error> -->
        </mat-form-field>
        <button mat-button class="button-primary" style="margin-top:13px;" type="submit"
          color="vov-ui-primary">Search</button>
        <span><a style="padding:22px;text-decoration: none; color: #6A0721;
            font-weight: bold;" [routerLink]="" color="vov-ui-primary" (click)="reset()">Reset</a></span>
      </form>
    </mat-dialog-content>
  </div>
</ng-template>
</div>